import { ChangeDetectorRef, Component, ComponentFactoryResolver, ElementRef, HostListener, OnDestroy, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { GlobalServices } from '../global.services';
import { ApiService } from '../api.service';
import { Subject, Subscription } from 'rxjs';
import { baseUrls } from '../appConstant';
// import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
// import { regExpEscape } from '@ng-bootstrap/ng-bootstrap/util/util';
import { ActivatedRoute, Router } from '@angular/router';
import { ProductService } from '../services/product.service';

declare var $: any;


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, OnDestroy {

  public userDetails: any;
  public imgSrc: any = 'assets/images/profile-picture.png';
  public clickcheck = 0;
  public responseMessage = '';
  public showAlert = false;
  mode: string;
  public searchBar = new Subject<string>();
  public search: string = '';
  public openSearch: boolean = false;
  public globalurl = baseUrls['global'];
  public emailtoken = '';
  private loginDetectorSubscription: Subscription;

  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (this.globalServices.isBrowser) {
      if ($('.user-setting').hasClass('d-none') && $('.user-setting').length > 0) {
      }
      else if ($('.user-setting').length > 0) {
        if (!document.getElementById('user-settings-menu').contains(event.target) && this.clickcheck !== 0) {
          this.clickcheck = 0;
          $('#user-setting').addClass('d-none');
        } else {
          this.clickcheck = 1;
        }
      }
    }
  }
  constructor(public globalServices: GlobalServices,
    public viewContainerRef: ViewContainerRef,
    public cfr: ComponentFactoryResolver,
    public httpService: ApiService,
    private cd: ChangeDetectorRef,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private productService: ProductService) {
    if (this.globalServices.isBrowser) {
      this.userDetails = localStorage.getItem('userDetails') ? JSON.parse(localStorage.getItem('userDetails')) : null;
      this.imgSrc = this.userDetails && this.userDetails['images'] && this.userDetails['images']['path'] ? baseUrls['images'] + this.userDetails['images']['path'] + this.userDetails['images']['name'] : 'assets/images/profile-picture.png';
    }
    this.loginDetectorSubscription = this.globalServices.subjectTriggerForLoginDetectAtHeader.subscribe((responseChange: any) => {
      this.globalServices.isLoggedIn = responseChange;
      this.cd.detectChanges();
    })
  }
  showHeader = false;
  subscriptionForHeader = new Subscription;
  userActivityLog;
  ngOnInit(): void {
    if (this.globalServices.isBrowser) {
      this.subscriptionForHeader = this.globalServices.hideHeader.subscribe((response) => {
        if (response) {
          this.showHeader = false;
          this.cd.detectChanges();
        }
        else {
          this.showHeader = true;
          this.cd.detectChanges();
        }
      })
      this.globalServices.headerviewcontainerhelper = this.viewContainerRef;
      this.globalServices.headercrf = this.cfr;
      setTimeout(() => {
        if (this.router?.url?.includes("register")) {
          this.showHeader = false;
        }
      }, 500);
      if (localStorage.getItem('inviteToken')) {
        this.opensignupmodal();
      }
      this.loadCountryData();
      this.loadShopCategoriesForMenu();
      this.loadWellnessStyleData();
      // fOR CATCHING THE TEXT SEARCH FROM url & BINDING TO VARIBALE 
      setTimeout(() => {
        if (this.router?.url?.includes('text')) {
          let textInUrl = this.router.url;
          this.searchText = textInUrl?.split("text=")[1]?.split(";")[0];;
        }
      }, 3000)
    }
    if (this.globalServices.isBrowser && !this.globalServices.isLoggedIn) {
      this.activatedRoute.queryParams.subscribe((paramsCatched: any) => {
        if (paramsCatched?.signupNewUser === "true") {
          this.globalServices.direcPaymentPage = true;
          this.opensignupmodal();
        }
        if (paramsCatched?.loginUser === "true") {
          this.openloginmodal();
        }
      })
    }
  }
  entersearch() {
    if (this.search !== '') {
      window.location.href = this.globalurl + 'travel/categories?globalSearch=' + this.search;
    }
  }

  openloginmodal() {
    this.globalServices.viewcontainerhelper = this.viewContainerRef;
    this.globalServices.triggerlogin(this.viewContainerRef, this.cfr);
  }

  opensignupmodal() {
  }


  public logOut() {
    this.globalServices.logout()
  }

  showprofilemenu($event, type: any) {

    if (this.globalServices.isBrowser) {
      $('#' + type).removeClass('d-none');
    }
  }

  sendemail() {
    if (this.globalServices.isBrowser) {
      let url = 'user/verify-email';
      let data = { email: localStorage.getItem('userEmail') };
      this.mode = 'indeterminate';
      this.httpService.postFormData(url, data).subscribe(response => {
        this.mode = 'determinate';
        if (response.success) {
          this.showAlert = true;
          this.responseMessage = 'Email verification link sent successfully!';
        } else {
          this.showAlert = true;
          this.responseMessage = response.message;
        }
      });
    }
  }

  public triggerCloseEvent() {
    this.showAlert = false;
  }

  logoClick() {
    if (this.globalServices.isLoggedIn) {
      this.router.navigate(['/'])
    } else {
      this.router.navigate(['/'])
    }
  }

  ngOnDestroy() {
    this.loginDetectorSubscription.unsubscribe();
    this.subscriptionForHeader.unsubscribe();
  }

  openSectionForLogin() {
    // FOR pop up login new section
    if (document.getElementById("newSignInPopUp")?.classList?.contains("active-login-popup")) {
      document.getElementById("newSignInPopUp")?.classList?.remove("active-login-popup");
    }
    else {
      document.getElementById("newSignInPopUp")?.classList?.add("active-login-popup");
    }
  }
  openSectionForLogout() {
    // FOR pop up logout new section
    if (document.getElementById("AfterNewSignInPopUp")?.classList?.contains("active-login-popup")) {
      document.getElementById("AfterNewSignInPopUp")?.classList?.remove("active-login-popup");
    }
    else {
      document.getElementById("AfterNewSignInPopUp")?.classList?.add("active-login-popup");
    }
  }

  shopCategories;
  loadShopCategoriesForMenu() {
    this.productService.postCategoryOfProducts({ start: 0, length: 15 })?.subscribe((resOfCategories: any) => {
      if (resOfCategories?.data?.length > 0) {
        this.shopCategories = resOfCategories?.data;
      }
    })
  }
  wellnessStyleData;
  loadWellnessStyleData() {
    let urlactivitiesData = 'home/category-subcategory';
    this.httpService.getData(urlactivitiesData).subscribe(response => {
      if (response) {
        this.wellnessStyleData = response;
      }
    });
  }
  resCountryData
  loadCountryData() {
    let Url = "global/destinations";
    this.httpService.getData(Url).subscribe(response => {
      if (response) {
        this.resCountryData = response;
      }
    });
  }
  navigationToggleButton() {
    if (document.body.classList?.contains("overpage-hidden")) {
      document.body.classList.remove("overpage-hidden");
      document.getElementById("htmlTagId").classList?.remove("overpage-hidden");
    }
    else {
      document.body.classList.add("overpage-hidden");
      document.getElementById("htmlTagId").classList?.add("overpage-hidden");
    }
  }
  
  addOrRemoveClass(indexPassed) {
    if (this.globalServices?.isBrowser) {
      let elements = document?.getElementsByClassName("menuListItem");
      for (let i = 0; i < elements?.length; i++) {
        if (i == indexPassed) {
          if (elements[i]?.classList?.contains("active-menu")) {
            elements[i]?.classList?.remove("active-menu");
          }
          else {
            elements[i]?.classList?.add("active-menu");
          }
        }
        else {
          elements[i]?.classList?.remove("active-menu");
        }
      }
    }
  }

  menuLavel3AddOrRemoveClassForDestination(eventPassed) {
    eventPassed?.stopPropagation();
    if (document?.getElementById('menuLavel3AddOrRemoveClassIdForDestination')?.classList?.contains('active-lavel-3')) {
      document?.getElementById('menuLavel3AddOrRemoveClassIdForDestination')?.classList?.remove('active-lavel-3');
    }
    else {
      document?.getElementById('menuLavel3AddOrRemoveClassIdForDestination')?.classList?.add('active-lavel-3');
    }
  }
  menuLavel3AddOrRemoveClassForWellnessStyle(eventPassed) {
    eventPassed?.stopPropagation();
    if (document?.getElementById('menuLavel3AddOrRemoveClassIdForWellnessStyle')?.classList?.contains('active-lavel-3')) {
      document?.getElementById('menuLavel3AddOrRemoveClassIdForWellnessStyle')?.classList?.remove('active-lavel-3');
    }
    else {
      document?.getElementById('menuLavel3AddOrRemoveClassIdForWellnessStyle')?.classList?.add('active-lavel-3');
    }
  }
  menuLavel3AddOrRemoveClass(eventPassed) {
    eventPassed?.stopPropagation();
    if (document?.getElementById('menuLavel3AddOrRemoveClassId')?.classList?.contains('active-lavel-3')) {
      document?.getElementById('menuLavel3AddOrRemoveClassId')?.classList?.remove('active-lavel-3');
    }
    else {
      document?.getElementById('menuLavel3AddOrRemoveClassId')?.classList?.add('active-lavel-3');
    }
  }
  showDestinations = false;
  showTravel = true;
  addActiveClasstoThisNavLink(eventPassed, indexPassed) {
    eventPassed?.stopPropagation();
    if (this.globalServices?.isBrowser) {
      let elements = document?.getElementsByClassName("TravelSubMenu");
      for (let i = 0; i < elements?.length; i++) {
        if (i == indexPassed) {
          if (elements[i]?.classList?.contains("active")) {
          }
          else {
            elements[i]?.classList?.add("active");
          }
        }
        else {
          elements[i]?.classList?.remove("active");
        }
      }
      if (indexPassed == 0) {
        this.showDestinations = false;
        this.showTravel = true;
      }
      if (indexPassed == 1) {
        this.showDestinations = true;
        this.showTravel = false;
      }
      if (indexPassed == 2) {
        this.showDestinations = false;
        this.showTravel = false;
      }
    }

  }
  baseUrls = baseUrls;
  subCategoryOfShopClick(eventPassed) {
    eventPassed?.stopPropagation();
    this.navigationToggleButton();
  }
  shopWellSectionClick(event) {
    event?.stopPropagation();
    if (window.screen.availWidth > 1100) {
      location.href = this.baseUrls?.hostedUrl + "shopwell";
    }
    else {
      this.addOrRemoveClass(2);
    }
  }
  navigateToProduct(object, type) {
    let queryParam: any = {};
    let link = '';
    if (type == 'country') {
      queryParam.country = object.slug
    } else if (type == 'programCat') {
      queryParam.programCategory = object.slug
      link = 'categories?programCategory=' + object.slug + '&isFromHeader=true';
    } else if (type == 'state') {
      queryParam.state = object.slug
    } else {
      queryParam.programSubCategory = object.slug
      link = this.baseUrls?.hostedUrl + 'travel/' + 'categories?programSubCategory=' + object.slug + '&isFromHeader=true';
    }
    queryParam['isFromHeader'] = true;
    return link;
  }
  goToTravelWellnessStyle(object, type) {
    if (this.globalServices?.isBrowser) {
      let queryParam: any = {};
      let link = '';
      if (type == 'programCat') {
        queryParam.programCategory = object.slug
        link = 'categories?programCategory=' + object.slug + '&isFromHeader=true';
        location.href = this.baseUrls?.hostedUrl + "travel/" + link
      }
    }
  }
  getlinkfromstate(object, region, country) {
    if (this.globalServices?.isBrowser) {
      return this.baseUrls?.hostedUrl + 'travel/destinations/' + region + '/' + country + '/' + object.slug;
    }
  }
  navigateFromCountries(object, region, slug) {
    if (this.globalServices?.isBrowser) {
      window.location.href = this.baseUrls?.hostedUrl + 'travel/destinations/' + region + '/' + slug;
    }
  }
  clickOnCountryInDestinationsInMobile(indexPassed) {
    if (indexPassed == 0 || indexPassed > 0) {
      const elements = document.getElementsByClassName("DestinationCountrySubMenu");
      for (let i = 0; i < elements?.length; i++) {
        if (i == indexPassed) {
          if (elements[i]?.classList?.contains("hideByDefaultOnMobile")) {
            elements[i]?.classList?.remove("hideByDefaultOnMobile");
            elements[i]?.classList?.add("showOnMobile");
          }
        }
        else {
          elements[i]?.classList?.add("hideByDefaultOnMobile");
        }

      }
    }
  }
  travelWellSectionClick(event) {
    event?.stopPropagation();
    if (window.screen.availWidth > 1100) {
      location.href = this.baseUrls?.hostedUrl + "travel";
    }
    else {
      this.addOrRemoveClass(1);
    }
  }
  moveToClasses(eventPassed) {
    eventPassed?.stopPropagation();
    window.location.href = this.baseUrls?.hostedUrl + "livewell/classes";
  }
  moveToPrograms(eventPassed) {
    eventPassed?.stopPropagation();
    window.location.href = this.baseUrls?.hostedUrl + "livewell/programs";
  }
  moveToOneToOne(eventPassed) {
    eventPassed?.stopPropagation();
    window.location.href = this.baseUrls?.hostedUrl + "livewell/personal-coaching";
  }
  liveWellSectionClick(event) {
    event?.stopPropagation();
    if (window.screen.availWidth > 1100) {
      location.href = this.baseUrls?.hostedUrl + "livewell";
    }
    else {
      this.addOrRemoveClass(0);
    }
  }
  subcategoryOfShopClicked(categoryInfo, subCategoryInfo) {
    if (subCategoryInfo && categoryInfo) {
      return this.baseUrls?.hostedUrl + "shopwell/category/" + categoryInfo?.slug + ";subcategory=" + subCategoryInfo?._id;
    }
  }
  categoryOfShopClicked(categoryInfo) {
    if (categoryInfo) {
      location.href = this.baseUrls?.hostedUrl + "shopwell/category/" + categoryInfo?.slug;
    }
  }
  searchInSectionSelectedValue = "all";
  searchInArea(eventPassed) {
    this.searchInSectionSelectedValue = eventPassed?.target?.value;
  }
  searchText;
  searchTextEnter(eventPassed) {
    if (eventPassed?.key == "Enter" && eventPassed?.keyCode == 13) {
      this.searchNow(eventPassed?.target?.value);
    }
  }

  searchNow(searchText) {
    if (searchText) {
      let areaForSearch = "all";
      let subSectionForSearch = "digital";
      if (this.searchInSectionSelectedValue == "all") {
        areaForSearch = "all";
        subSectionForSearch = "digital";
      }
      if (this.searchInSectionSelectedValue == "digital") {
        areaForSearch = "digital";
        subSectionForSearch = "digital";
      }
      if (this.searchInSectionSelectedValue == "travel") {
        areaForSearch = "travel";
        subSectionForSearch = "travel";
      }
      if (this.searchInSectionSelectedValue == "shop") {
        areaForSearch = "shop";
        subSectionForSearch = "shop";
      }
      this.router.navigate(['/search', { text: searchText.trim(), area: areaForSearch, sub: subSectionForSearch }])
    }
  }
  goToUrl(urlLink) {
    if (this.globalServices?.isBrowser && urlLink) {
      window.open(urlLink);
    }
  }

  menuLavel3AddOrRemoveClassForShopwell(eventPassed) {
    if (window.screen.availWidth > 1100) {
      location.href = this.baseUrls?.hostedUrl + "shopwell";

    }
    else {
      if (document?.getElementById('menuLavel3AddOrRemoveClassIdForShopwell')?.classList?.contains('active-lavel-3')) {
        document?.getElementById('menuLavel3AddOrRemoveClassIdForShopwell')?.classList?.remove('active-lavel-3');
        setTimeout(() => {
          this.addOrRemoveClass(2);
        }, 500)
      }
      else {
        this.addOrRemoveClass(2);
        setTimeout(() => {
          document?.getElementById('menuLavel3AddOrRemoveClassIdForShopwell')?.classList?.add('active-lavel-3');
        }, 500);
      }
    }
  }
  moveToJoinTravelClub() {
    if (this.globalServices?.isBrowser) {
      window.location.href = this.baseUrls?.hostedUrl + "travel/club";
    }
  }
  menuLavel3AddOrRemoveClassForTravelClub(eventPassed) {
    eventPassed?.stopPropagation();
    if (window.screen.availWidth < 756) {
      this.moveToJoinTravelClub();
      return;
    }
    if (document?.getElementById('menuLavel3AddOrRemoveClassIdForTravelClub')?.classList?.contains('active-lavel-3')) {
      document?.getElementById('menuLavel3AddOrRemoveClassIdForTravelClub')?.classList?.remove('active-lavel-3');
    }
    else {
      document?.getElementById('menuLavel3AddOrRemoveClassIdForTravelClub')?.classList?.add('active-lavel-3');
    }
  }
  goToSubscriptionPage() {
    if (localStorage.getItem('userActivityLog')) {
      this.userActivityLog = JSON.parse(localStorage.getItem('userActivityLog'))
      if (localStorage?.getItem("planId") || this.globalServices?.planId) {
        if (this.userActivityLog?.planSelectionCompleted) {
          this.router.navigate([`/register/${this.globalServices?.planId ?
            this.globalServices?.planId :
            localStorage?.getItem("planId")
            }-${this.userActivityLog?.planSelectionCompleted}`])
        }
        else {
          if (this.userActivityLog?.loginFromUrl) {
            this.router.navigate([`/register/${this.globalServices?.planId ?
              this.globalServices?.planId :
              localStorage?.getItem("planId")
              }-${this.userActivityLog?.loginFromUrl}`])
          }
          else {
            this.router.navigate([`/membership/app`])
          }
        }
      }
    }
  }

  ssoLogin() {
    location.href = baseUrls['ssoUrl']
  }
}


